module.exports = __webpack_public_path__ + "static/img/icon-print.94199ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myBrand/component/img/icon-print.svg
// module id = Z+Z3
// module chunks = 66